import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Container } from "react-bootstrap";

import noItemsFoundImage from "../../image/search/no-items-found.png";
import searchImage from "../../image/search/search.png";
import { mailiSearchSimulationsApi, serachApi } from "../../utility/api/apiList";

import useAxios from "../../hooks/useAxios";
import scrollToTop from "../../libs/scrollToTop";

import SearchBar from "../../components/public/search/searchBar";
import SearchResultCarouselComponent from "../../components/public/search";
import ShowAllResult from "../../components/public/search/ShowAllResult";

import { StyledSearchContainer } from "./styledSearchContainer";

const SearchContainer = () => {
  const [showAllItems, setShowAllItems] = useState(false);
  const [filter, setFilter] = useState({
    isFilter: false,
    filterName: null,
    filterType: null,
  });
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const queryParams = params.get("q");

  const {
    data: searchResult,
    isLoading: searchResultLoading,
    run: searchRun,
  } = useAxios({
    config: {
      method: "post",
      url: mailiSearchSimulationsApi,
      headers: {
        "Content-Type": "application/json",
      },
      transformRequest: [
        (data, headers) => {
          delete headers.Authorization;
          return JSON.stringify(data);
        },
      ],
    },
  });

  const {
    data: filterCategories,
    isLoading: filterCategoriesLoading,
    run: filterCategoriesRun,
  } = useAxios({
    url: serachApi,
  });

  const searchValue = (page) => {
    searchRun({
      q: queryParams,
      offset: (page - 1) * 12,
      limit: 12,
    }).then(() => {
      filterCategoriesRun(undefined, {
        q: queryParams,
      });
    });
  };

  useEffect(() => {
    document.title = "جستجو";
    scrollToTop();

    if (queryParams) {
      const page = +params.get("page");
      const filter = params.get("filter");
      switch (true) {
        case params.has("page") && params.has("filter"):
          setShowAllItems(true);
          filterCategoriesRun(undefined, {
            q: queryParams,
            type: filter,
            page_size: 12,
            page: page,
          });
          break;
        case params.has("page"):
          setShowAllItems(true);
          searchValue(page);
          break;
        default:
          searchValue(1);
          break;
      }
    }
  }, []);

  let element = null;
  if (searchResult?.estimatedTotalHits === 0) {
    element = <p className="no-result text-center mt-5">موردی پیدا نشد!</p>;
  } else if (
    queryParams &&
    !showAllItems &&
    searchResult?.estimatedTotalHits !== 0
  ) {
    element = (
      <SearchResultCarouselComponent
        runAxios={{ searchRun, filterCategoriesRun }}
        searchResult={searchResult}
        setShowAllItems={setShowAllItems}
        filterCategories={filterCategories}
        filter={filter}
        setFilter={setFilter}
      />
    );
  }

  return (
    <StyledSearchContainer>
      <Container className={`search-wrapper px-0 pt-5 ${!showAllItems && "pb-5"}`}>
        <SearchBar
          params={params}
          runAxios={{ searchRun, filterCategoriesRun }}
          loading={{ searchResultLoading, filterCategoriesLoading }}
          showAllItems={showAllItems}
          setShowAllItems={setShowAllItems}
        />
        {element}
        <img
          src={
            searchResult?.estimatedTotalHits === 0 ? noItemsFoundImage : searchImage
          }
          alt="no-items-found"
          className={`image-background d-block mx-auto img-fluid 
          ${
            searchResult?.estimatedTotalHits !== 0 &&
            showAllItems &&
            "show-all-result"
          } 
          `}
        />
      </Container>
      {queryParams && showAllItems && (
        <ShowAllResult
          className="w-100"
          searchRun={searchRun}
          queryParams={queryParams}
          filter={filter}
          filterCategoriesRun={filterCategoriesRun}
          data={
            filterCategories?.results
              ? filterCategories?.results
              : searchResult?.hits
          }
          count={
            filterCategories?.count
              ? filterCategories?.count
              : searchResult?.estimatedTotalHits
          }
        />
      )}
    </StyledSearchContainer>
  );
};

export default SearchContainer;
